import React from 'react';
import { ProjectCostsStats } from './ProjectCostsStats';
import { ProjectCostsTrends } from './ProjectCostsTrends';
import { ProjectCostsContractInfo } from './ProjectCostsContractInfo';

export function ProjectCostsSidebar({ data }: { data: any }) {
  return (
    <div className="space-y-6">
      {/* Phân bổ chi phí */}
      <ProjectCostsStats />

      {/* Tình hình chi phí theo thời gian */}
      <ProjectCostsTrends />

      {/* Thông tin hợp đồng */}
      <ProjectCostsContractInfo />
    </div>
  );
}
